<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules" >
<!--      <a-form-model-item label="公告类型" prop="noticeType" >-->
<!--        <a-select placeholder="请选择" v-model="form.noticeType" style="width: 100%;" >-->
<!--          <a-select-option :key="1">通知</a-select-option>-->
<!--          <a-select-option :key="2">公告</a-select-option>-->
<!--        </a-select>-->
<!--      </a-form-model-item>-->
      <a-form-model-item label="标题" prop="noticeTitle">
        <a-input size="large" width="200px" v-model="form.noticeTitle" placeholder="请输入标题" />
      </a-form-model-item>
      <a-form-model-item label="图片" prop="imgUrl" >
        <file-upload v-model="form.imgUrl" type="image" @change="changeSwiper"></file-upload>
      </a-form-model-item>
      <a-form-model-item label="内容" prop="noticeContent">
        <editor v-model="form.noticeContent" />
      </a-form-model-item>
    </a-form-model>
    <div class="bottom-control">
      <a-space>
        <a-button type="primary" :loading="submitLoading" @click="submitForm">
          保存
        </a-button>
        <a-button type="dashed" @click="cancel">
          取消
        </a-button>
      </a-space>
    </div>
  </a-drawer>
</template>

<script>

import { getNotice, addNotice, updateNotice } from '@/api/system/notice'
import Editor from '@/components/Editor'
import bus from '@/utils/bus'
import events from '@/components/MultiTab/events'

export default {
  name: 'NoticeForm',
  components: {
    Editor
  },
  dicts: ['sys_notice_status', 'sys_notice_type'],
  data() {
    return {
      wrapperCol: { span: 48 },
      submitLoading: false,
      total: 0,
      id: undefined,
      formTitle: '',
      // 表单参数
      form: {
        id: undefined,
        noticeTitle: undefined,
        noticeType: 1,
        noticeContent: '',
        imgUrl:null,
        status: 1,
        bstatus: 1
      },
      rules: {
        noticeType: [{ required: true, message: '公告类型不能为空', trigger: 'change' }],
        noticeTitle: [{ required: true, message: '公告标题不能为空', trigger: 'blur' }],
        noticeContent: [{ required: true, message: '请输入内容', trigger: 'blur' }]
      },
      open: false
    }
  },
  filters: {
  },
  created() {
  },
  computed: {
  },
  watch: {
  },
  mounted() {
   /* this.id = this.$route.params.id
    this.formTitle = this.$route.params.formTitle
    if (this.id) {
      this.handleUpdate(this.id)
    } else {
      this.handleAdd()
    }*/
  },
  methods: {
    changeSwiper(e) {
      console.log(e);
      this.form.imgUrl = e;
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    changeStatus(e) {
      let status = e.target.value
      this.form.status = status === '0' ? '1' : '0'
    },
    // 表单重置
    reset() {
      this.form = {
        id: undefined,
        noticeTitle: undefined,
        noticeType: 1,
        noticeContent: '',
        imgUrl:null,
        status: 1,
        bstatus: 1
      }
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset()
      this.formTitle = '添加公告';
      this.open = true;
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      const id = row ? row.id : ids
      const noticeId = id
      getNotice(noticeId).then(response => {
        let str = response.data.status
        this.$set(response.data, 'bstatus', str)
        this.form = response.data
        this.open = true;
        this.formTitle = '修改公告'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          // this.submitLoading = true
          if (this.form.id !== undefined) {
            updateNotice(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              // 去更新列表页的数据
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addNotice(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    },
    back() {
      let pages = this.$store.pages;
      pages.indexOf(this.$route)
      events.$emit('close', pages.indexOf(this.$route))
      this.$router.push('/system/notice')
    },
    onClose() {
      this.open = false
    },
    handleSubmit() {
      this.$refs.baseForm.validate(valid => {
        if (valid) {
          this.open = true
        } else {
          return false
        }
      })
    },
    //关闭当前标签页

  }
}
</script>
